export const SHOW_SOCIAL_POST_DIALOG = 'SHOW_SOCIAL_POST_DIALOG';
export const HIDE_SOCIAL_POST_DIALOG = 'HIDE_SOCIAL_POST_DIALOG';



// WEBPACK FOOTER //
// ./src/store/modules/modals/mutation-types.js